<template>
  <div>
    <!-- 提示信息1 -->
    <alertStep :useDefault="true" :useDefaultNumber="3"/>
    <!-- 表单 -->
    <form-text-box
      ref="schemeRentInfoBox"
      :dataList="isGroup ? schemeRentInfo_group_formConfig : schemeRentInfo_formConfig"
      :rules="schemeRentInfo_formRule"
      :model="schemeRentInfo_model"
      :column="2"
    />
  </div>
</template>
<script>
import alertStep from '@/components/rentCalculateConfig/alertStep'
import rentInfoFn from './config/schemeRentInfo.js'
import { mapState } from 'vuex'
import SelectOption from '@/store/dict/selectOptionDict'
import { FEE_CODE_MAP, CATEGORY_FEE_MAP, CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import isNil from 'lodash/isNil'

export default {
  name: 'SchemeRentInfo',
  components: { alertStep },
  props: {
    defaultRentInfo: {
      type: Object,
      default: () => ({
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        presentDays: '', // 赠送天数
        preFreeRentDays: '', // 前置免租天数
      }),
    },
    tableData: {
      type: Array,
      default: () => ([]),
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const {
      schemeRentInfo_model,
      schemeRentInfo_formRule,
    } = rentInfoFn.call(this)
    return {
      SelectOption,
      schemeRentInfo_model,
      schemeRentInfo_formRule,
      rentPeriodType: 'select',
      // 方案收费list
      feeTableData: [],
    }
  },
  watch: {
    defaultRentInfo: {
      handler(val) {
        const rentInfoKey = ['rentCategory', 'rentPeriod', 'presentDays', 'preFreeRentDays', 'rentPeriodType']
        rentInfoKey.forEach((key) => {
          if (val[key]) {
            this.schemeRentInfo_model[key] = val[key]
          }
        })
        if (this.isGroup) {
          this.rentPeriodType = [3, 6, 12].includes(Number(val.rentPeriod)) ? 'select' : 'input'
        }
        this.updateData()
      },
      deep: true,
    },
    tableData: {
      handler(val) {
        if (!val.length) return
        //  根据【类别】获取不同类别对应的费项
        const someFeeList = this[CATEGORY_FEE_MAP[Number(this.schemeRentInfo_model.rentCategory)]]
        if (someFeeList && someFeeList.length) {
          this.setFeeItemArr(someFeeList, val)
        } else {
          this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[Number(this.schemeRentInfo_model.rentCategory)] }).then((res) => {
            this.setFeeItemArr(res.data, val)
          })
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      categoryList: (state) => state.rentPlan.categoryList, // 类别
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
    schemeRentInfo_formConfig() {
      const { schemeRentInfo_formConfig } = rentInfoFn.call(this)
      return schemeRentInfo_formConfig
    },
    schemeRentInfo_group_formConfig() {
      const { schemeRentInfo_group_formConfig } = rentInfoFn.call(this)
      return schemeRentInfo_group_formConfig
    },
    categoryData() {
      // 个人：1，企业：2
      if (Number(this.$route.query.type) === 2) {
        return this.categoryList.filter((i) => i.code !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI)
      }
      return this.categoryList
    },
  },
  mounted() {
    // 获取类别list
    if (this.categoryList === null || !this.categoryList.length) {
      this.$store.dispatch('getRentCategory')
    }
    if (this.$route.query.id) {
      this.queryFeeList()
    } else {
      this.queryFeeList(this.addRequiredFee)
    }
  },
  methods: {
    // 请求费项列表
    queryFeeList(cb) {
      if (!this.schemeRentInfo_model.rentCategory) {
        this.schemeRentInfo_model.rentCategory = CATEGORY_CODE_MAP.ZU_CHE
      }
      const someFeeList = this[CATEGORY_FEE_MAP[this.schemeRentInfo_model.rentCategory]]
      if (!someFeeList || !someFeeList.length) {
        this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[this.schemeRentInfo_model.rentCategory] }).then((res) => {
          cb && cb(res.data)
        })
      } else {
        cb && cb(someFeeList)
      }
    },
    // 设置必填费项
    addRequiredFee(someFeeList) {
      // 过滤必填费项
      const requiredFee = someFeeList.filter((item) => item.required) || []
      let nf = requiredFee.map((i) => {
        const item = {}
        item.fundType = i.code
        item.name = i.name
        item.required = i.required
        item.toast = i.toast
        item.isConfirm = false
        return item
      })
      // 若类型选的是【以租代购】,(首付款/租金)和(全款)是互斥关系，table默认展示 首付款/租金，全款需过滤掉
      if (Number(this.schemeRentInfo_model.rentCategory) === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
        nf = nf.filter((i) => Number(i.fundType) !== FEE_CODE_MAP.QUAN_KUAN) // 15-全款
      }
      this.feeTableData = nf
      this.updateData()
    },
    setFeeItemArr(someFeeList, schemePlanFeeList) {
      const newArray = []
      const isDataOutdated = ({ amountAccuracy }) => isNil(amountAccuracy) // 检测计租配置数据是不是旧数据

      schemePlanFeeList.forEach((item) => {
        item.type = Number(item.type) || Number(item.fundType) // 费项code
        const newItem = { ...item }
        const findFee = someFeeList.find((i) => Number(i.code) === item.type)
        if (findFee) {
          // 旧版本的数据标识为isConfirm为false
          // 即：旧版本的数据会展示为“未配置”状态，需要打开配置弹窗重新配置，配置后，数据会转换成新格式
          newItem.isConfirm = !isDataOutdated(newItem)
          newItem.toast = findFee.toast // 提示语
          newItem.required = findFee.required // 是否必填费项
          newItem.name = findFee.name // 费项名称
          newItem.fundType = item.type || item.fundType // 费项code（押金，租金......）
          newItem.payMode = item.payMode || item.payMethod // 收款方式
          newArray.push(newItem)
        }
      })

      this.feeTableData = newArray
      this.updateData()
    },
    changeRentPeriod(type) {
      this.schemeRentInfo_model.rentPeriodType = type
      this.schemeRentInfo_model.rentPeriod = ''
      this.updateData()
    },
    changeGroupRentPeriod(type) {
      this.rentPeriodType = type
      this.schemeRentInfo_model.rentPeriod = ''
    },
    updateData() {
      this.$emit('updateInfo', this.schemeRentInfo_model, this.feeTableData)
    },
    // 获取表单数据
    getFormData() {
      let returnData = false
      this.$refs.schemeRentInfoBox.getRefs().validate((validate) => {
        if (validate) {
          returnData = {
            rentCategory: Number(this.schemeRentInfo_model?.rentCategory), // 类别
            rentPeriod: Number(this.schemeRentInfo_model?.rentPeriod), // 预计租赁周期
            presentDays: Number(this.schemeRentInfo_model?.presentDays), // 赠送天数
            preFreeRentDays: Number(this.schemeRentInfo_model?.preFreeRentDays), // 前置免租天数
            rentPeriodType: Number(this.schemeRentInfo_model?.rentPeriodType),
          }
        } else {
          this.autoAnchorPoint(true)
        }
      })
      return returnData
    },
    // 锚点定位
    autoAnchorPoint(toastFlag) {
      toastFlag && this.$message.error('租赁周期不能为空，请先填写“预计租赁周期”')
      this.$refs.schemeRentInfoBox.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.$refs.schemeRentInfoBox.getRefs().validate().catch(() => {}) // 表单校验
    },
  },
}
</script>
